import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-business-model-section',
  templateUrl: './business-model-section.component.html',
  styleUrls: ['./business-model-section.component.scss']
})
export class BusinessModelSectionComponent implements OnInit {

  constructor(
    private router: Router 
  ) { }

  public agent: string = "../assets/img/pos.png";
  public merchant: string = "../assets/img/group.svg";
  public gateway: string = "../assets/img/chart.png";

  public isLowerPart1 = true;
  public isLowerPart2 = false;
  public isLowerPart3 = false;
  // public isLowerPart2 = true;
  // public isLowerPart3 = true;

  public showAboutSectionText(id: any, event: any) {
    // console.log('mouse over event', 'id', id);
  if (id == 1) {
    this.isLowerPart1 = true
    this.isLowerPart2 = false;
    this.isLowerPart3 = false;

  }
  else if (id == 2) {
    this.isLowerPart1 = false;
    this.isLowerPart2 = true;
    this.isLowerPart3 = false;

  }
  else if (id == 3) {
    this.isLowerPart1 = false;
    this.isLowerPart2 = false;
    this.isLowerPart3 = true;
  }
  else { }

}

navigate(url: any){
  // console.log('click', url );
  if(url == 1){
    this.router.navigate([this.information[0]?.url]);
  }
  else if(url == 2){
    this.router.navigate([this.information[1]?.url]);
  }else if(url == 3){
    //link to external site from alcurateco
    window.location.assign(this.information[2]?.url)
  }
}

public information: any = [
  {
    id: 1,
    icon: this.agent,
    title: "Become POS agent",
    text: `Wherever you are in Abuja, you can order our car services.
         via the app or call our front desk `,
    urlText: "Get Huiospay POS device",
    url: "become-agent"
  },
  {
    id: 2,
    icon: this.merchant,
    title: "Become POS merchant",
    text: `Beetle Taxis needs you and your vehicle, register with us,
    in order to render professional chauffer services`,
    urlText: "Register and get a multiple POS device with us for various location",
    url: "become-agent"
  },
  {
    id: 3,
    icon: this.gateway,
    title: "Payment Gateway",
    text: `All our drivers have been checked and approved by the national security.
      Every driver is dressed appropriately, easy to identify
      and professionally trained.`,
    urlText: "Apply for our Payment Gateway integration",
    url: "https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16"
  }
]



  ngOnInit(): void {
  }

}
